var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"d-flex justify-content-center align-items-center p-0 m-0 vw-100 vh-100",attrs:{"fluid":""}},[_vm._t("default"),_c('copyright-panel')],2)}
var staticRenderFns = []

export { render, staticRenderFns }